export default __webpack_public_path__ + "static/media/Boots of the Assailant.eb7ca9f1.jpg";